"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFromRange = void 0;
const getFromRange = (ranges, checkValue) => {
    return (ranges.filter((r) => {
        return (r.high == null || r.high >= checkValue) && (r.low == null || r.low <= checkValue);
    })[0]?.value ?? null);
};
exports.getFromRange = getFromRange;
